import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core'

@Component({
  selector: 'mmx-action-card',
  templateUrl: './action-card.component.html',
  styleUrls: ['./action-card.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionCardComponent {
  @Input() selected = false
  @Input() unselectable = false
  @Output() selectedChange = new EventEmitter<boolean>()

  select() {
    this.selected = true
    this.selectedChange.emit(this.selected)
  }

  unselect() {
    if (this.unselectable) {
      this.selected = false
      this.selectedChange.emit(this.selected)
    }
  }
}
